const getPatientDob2 = ({ patient, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return patient['Date of Birth'].replace(/[/]/g, '').substring(2, 4);
};

export default getPatientDob2;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientDob2.js